import Vue from 'vue'
import Router from 'vue-router'

const load = (view) => () => import(`@/pages/${view}`)

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: load('home/index')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js